module.exports = __webpack_public_path__ + "static/media/anthropic.49709694.png";